export default "__VITE_ASSET__BR10HILH__"